import styled from 'styled-components';

import { flexCenter, flexStart } from '../../../style/reusableStyle';

export const OnboardingFormsContainer = styled.div`
  flex: 1;
  margin: 144px 30px 20px 88px;
  max-width: 600px;

  & .title {
    margin-bottom: 40px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin: 40px 30px 20px 30px;
    width: calc(100% - 60px);

    & .title {
      margin-bottom: 20px;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 30px;
`;

export const CardContainer = styled.div`
  ${flexStart}
  gap:8px;
  & svg {
    height: 18px;
    width: 28px;
  }
`;

export const CongratulationWrapper = styled.div`
  ${flexCenter(0)};
  margin-bottom: 40px;
`;
